<template>
  <div class="job-schedule-team-body">
    <v-layout class="d-block">
      <template v-if="team.assigned_team">
        <v-col md="12">
          <v-list-item
            v-for="(engineer, index) in getAssignedTeamData()"
            :key="index"
            class="ma-2"
          >
            <v-list-item-avatar>
              <v-img
                :lazy-src="$defaultProfileImage"
                :src="engineer.profile_logo"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-size-14 font-weight-500">
                {{ engineer.display_name }}</v-list-item-title
              >
              <!-- <v-list-item-subtitle class="font-size-12 font-weight-500">
                {{ getTeamDesignation(engineer) }}</v-list-item-subtitle
              > -->
            </v-list-item-content>
            <v-list-item-icon
              v-on:click="removeAssignedTeam({ engineer, index })"
              link
            >
              <!-- <v-btn icon color="red lighten-1">
                <v-icon>mdi-close</v-icon>
              </v-btn> -->
            </v-list-item-icon>
          </v-list-item>
        </v-col>
        <v-col md="12">
          <v-checkbox
            label="Email team about assignment"
            :value="1"
            hide-details
            class="mr-4 mt-0"
            color="cyan"
            v-model.trim="team.email_team"
          ></v-checkbox>
        </v-col>
      </template>
      <v-col md="12" v-else>
        <p class="font-size-16">No users are currently assigned</p>
      </v-col>
    </v-layout>
  </div>
</template>

<script>
import { JobScheduleTeamEventBus } from "@/core/lib/job/job.schedule.team.lib";
import { forEach, find } from "lodash";

export default {
  name: "job-schedule-team-body",
  data() {
    return {
      availableTeam: [],
      team: {
        assigned_team: new Array(),
        email_team: 1,
      },
    };
  },
  watch: {
    team: {
      deep: true,
      immediate: true,
      handler(param) {
        console.log(param);
        let EngineerId = [];
        let teamData = find(
          this.availableTeam,
          (row) => row.id == this.team.assigned_team
        );
        let teamId = 0;
        if (teamData) {
          teamId = teamData.id;
          // console.log(teamId,"teamiiiiiiii");
          if (teamData && teamData.team_data) {
            forEach(teamData.team_data, (row3) => {
              EngineerId.push(row3.staff_data.id);
            });
          }
        }

        JobScheduleTeamEventBus.$emit(
          "update:assigned-team",
          EngineerId,
          teamId
        );
      },
    },
  },
  methods: {
    getAssignedTeamData() {
      let assignedEnggData = [];
      let _this = this;

      let teamData = find(
        _this.availableTeam,
        (row) => row.id == this.team.assigned_team
      );

      if (teamData && teamData.team_data) {
        forEach(teamData.team_data, (row3) => {
          assignedEnggData.push({
            id: row3.staff_data.id,
            display_name: row3.staff_data.display_name,
            profile_logo: row3.staff_data.profile_logo,
            team_id: row3.team_id,
          });
        });
      }

      return assignedEnggData;
      /* forEach(this.team.assigned_team, (row) => {
        let teamData = find(_this.availableTeam, (row2) => row2.id == row);
        console.log(teamData, "teamData");
        if(teamData && teamData.team_data)
        {
          forEach(teamData.team_data, (row3) => {
            assignedEnggData.push({
              id:row3.staff_data.id,
              display_name:row3.staff_data.display_name,
              profile_logo:row3.staff_data.profile_logo,
              team_id:row3.team_id
            })
          })
        }
      });
      return assignedEnggData; */
    },
    getTeamUserName(id) {
      const _this = this;
      let index = _this.lodash.findIndex(_this.availableTeam, function (data) {
        return data.id == id;
      });
      // console.log(_this.availableTeam);
      if (index >= 0) {
        return _this.availableTeam[index].display_name;
      }
      return "N/A";
    },
    getTeamDesignation(id) {
      const _this = this;
      let index = _this.lodash.findIndex(_this.availableTeam, function (data) {
        return data.id == id;
      });
      if (index >= 0) {
        if (
          _this.lodash.isEmpty(_this.availableTeam[index].designation) === false
        ) {
          return _this.availableTeam[index].designation.value;
        }
        return "";
      }
      return "N/A";
    },
    getTeamUserProfile(id) {
      const _this = this;
      let index = _this.lodash.findIndex(_this.availableTeam, function (data) {
        return data.id == id;
      });
      if (index >= 0) {
        return this.$assetAPIURL(_this.availableTeam[index].profile_logo);
      }
      return null;
    },
    removeAssignedTeam({ engineer, index }) {
      JobScheduleTeamEventBus.$emit("remove:schedule-team", {
        engineer,
        index,
      });
    },
  },
  beforeDestroy() {
    /*JobScheduleTeamEventBus.$off("update:schedule-team");*/
  },
  created() {
    const _this = this;
    JobScheduleTeamEventBus.$on(
      "update:schedule-team",
      ({ availableTeam, assignedTeam }) => {
        _this.availableTeam = availableTeam;
        _this.team.assigned_team = assignedTeam;
      }
    );
  },
};
</script>
